import { render, staticRenderFns } from "./SideMenuTitle.vue?vue&type=template&id=b433f5e4&scoped=true&"
import script from "./SideMenuTitle.vue?vue&type=script&lang=js&"
export * from "./SideMenuTitle.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuTitle.vue?vue&type=style&index=0&id=b433f5e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b433f5e4",
  null
  
)

export default component.exports